'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupId$() {
  this.c6l = null;
  this.c6m = false;
  this.c6j = null;
  this.c6k = false;
}
export { $c_Lpresto_types$GroupId$ as $c_Lpresto_types$GroupId$ };
$p = $c_Lpresto_types$GroupId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupId$;
/** @constructor */
function $h_Lpresto_types$GroupId$() {
}
export { $h_Lpresto_types$GroupId$ as $h_Lpresto_types$GroupId$ };
$h_Lpresto_types$GroupId$.prototype = $p;
$p.cHw = (function() {
  if ((!this.c6m)) {
    this.c6l = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j1;
    this.c6m = true;
  }
  return this.c6l;
});
$p.p2 = (function() {
  if ((!this.c6k)) {
    this.c6j = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB;
    this.c6k = true;
  }
  return this.c6j;
});
var $d_Lpresto_types$GroupId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupId$, "presto.types$GroupId$", ({
  a0w: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupId$ as $d_Lpresto_types$GroupId$ };
var $n_Lpresto_types$GroupId$;
function $m_Lpresto_types$GroupId$() {
  if ((!$n_Lpresto_types$GroupId$)) {
    $n_Lpresto_types$GroupId$ = new $c_Lpresto_types$GroupId$();
  }
  return $n_Lpresto_types$GroupId$;
}
export { $m_Lpresto_types$GroupId$ as $m_Lpresto_types$GroupId$ };
//# sourceMappingURL=presto.types$-Group-Id$.js.map
